import { Accordion, Badge, Checkbox, Group, Modal, Stack, Text, Button } from '@mantine/core';
import { FilterCategory } from '../../data/mockFilters';
import { PersonFilter } from '../../types/filter';

interface FilterModalProps {
  opened: boolean;
  onClose: () => void;
  filterCategories: FilterCategory[];
  selectedFilters: PersonFilter[];
  onAddFilter: (categoryId: string, itemId: string) => void;
  onRemoveFilter: (categoryId: string, itemId: string) => void;
}

export function FilterModal({ 
  opened, 
  onClose, 
  filterCategories, 
  selectedFilters, 
  onAddFilter, 
  onRemoveFilter 
}: FilterModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Add Categories & Skills"
      size="lg"
    >
      <Text size="sm" c="dimmed" mb="lg">
        Select categories and skills to add to your CV. These help colleagues find your profile when searching.
      </Text>
      
      <Accordion multiple defaultValue={filterCategories.map(cat => cat.id)}>
        {filterCategories.map((category) => {
          // Count active items in each category
          const activeItems = category.items.filter(item => item.active);
          if (activeItems.length === 0) return null;
          
          // Count already selected items in this category
          const selectedCount = selectedFilters.filter(
            f => f.categoryId === category.id
          ).length;
          
          return (
            <Accordion.Item value={category.id} key={category.id}>
              <Accordion.Control>
                <Group justify="apart">
                  <Text fw={600}>{category.name}</Text>
                  {selectedCount > 0 && (
                    <Badge size="sm" variant="filled" color="blue">
                      {selectedCount} selected
                    </Badge>
                  )}
                </Group>
              </Accordion.Control>
              
              <Accordion.Panel>
                <Text size="sm" c="dimmed" mb="sm">
                  {category.description || `Select one or more ${category.name.toLowerCase()} to add to your CV.`}
                </Text>
                
                <Stack gap="xs" mt="md">
                  {activeItems.map(item => {
                    // Check if this item is already selected
                    const isSelected = selectedFilters.some(
                      f => f.categoryId === category.id && f.itemId === item.id
                    );
                    
                    return (
                      <Checkbox
                        key={item.id}
                        label={item.name}
                        description={item.description}
                        checked={isSelected}
                        onChange={(event) => {
                          if (event.currentTarget.checked) {
                            onAddFilter(category.id, item.id);
                          } else {
                            onRemoveFilter(category.id, item.id);
                          }
                        }}
                        styles={{
                          label: { fontWeight: 500 },
                          description: { fontSize: '0.8rem' }
                        }}
                      />
                    );
                  })}
                </Stack>
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion>
      
      <Group justify="flex-end" mt="xl">
        <Button onClick={onClose}>Done</Button>
      </Group>
    </Modal>
  );
} 